// openapi-fetch defaults to serializing array query params as repeated keys
// (`fields=a&fields=b`). The platform_api backend, however, reads list params
// using bracketed keys (e.g. `request.args.get("fields[]")`) across virtually
// every controller. The app used to talk to platform_api via axios, whose
// default serializer emitted exactly that bracket form, so those endpoints
// depend on it. This restores the bracket-array behavior for the platform_api
// client so list params (fields, ids, availabilities, ...) are received again.
export const bracketQuerySerializer = (
  query: Record<string, unknown>,
): string => {
  const parts: string[] = [];

  const encodePair = (key: string, value: unknown) => {
    if (value === undefined || value === null) return;
    parts.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
    );
  };

  for (const [key, value] of Object.entries(query ?? {})) {
    if (Array.isArray(value)) {
      // Tolerate keys that already carry the bracket suffix (some callers and
      // schema-defined params pass e.g. `user_fields[]`/`confidence[]`
      // directly) so we never double-bracket into `key[][]`.
      const arrayKey = key.endsWith("[]") ? key : `${key}[]`;
      value.forEach((item) => encodePair(arrayKey, item));
    } else {
      encodePair(key, value);
    }
  }

  return parts.join("&");
};
